import { IconsEnum } from '../../assets/icons/types';
import { itemsKeys } from '../../locales/keys';
import {
  FetchCacheGroupedItemsSortEnum,
  FetchGroupedItemsSortEnum,
  GroupedItemBindingStatuses,
  GroupedItemsGroupByEnum
} from './groupedItemsTypes';

export const INITIAL_GROUPED_ITEMS_FILTERS = {};
export const INITIAL_GROUPED_ITEMS_PAGE = 1;
export const INITIAL_GROUPED_ITEMS_SORT = [
  FetchGroupedItemsSortEnum.ITEM_CREATED_AT_DESC
];
export const INITIAL_GROUPED_ITEMS_LIMIT = 100;

export const INITIAL_CACHE_GROUPED_ITEMS_FILTERS = {};
export const INITIAL_CACHE_GROUPED_ITEMS_PAGE = 1;
export const INITIAL_CACHE_GROUPED_ITEMS_SORT = [
  FetchCacheGroupedItemsSortEnum.CREATED_AT_DESC
];
export const INITIAL_CACHE_GROUPED_ITEMS_LIMIT = 100;

export const groupedItemsGroupByLocalStorageKey = 'grouped-items-group-by';

export const defaultGroupedItemsGroupByState = {
  [GroupedItemsGroupByEnum.PROJECT]: false,
  [GroupedItemsGroupByEnum.TASK]: false,
  [GroupedItemsGroupByEnum.ITEM]: false,
  // [GroupedItemsGroupBy.ITEM_TAG]: false,
  [GroupedItemsGroupByEnum.ITEM_TAGS]: false,
  [GroupedItemsGroupByEnum.DATE]: false,
  [GroupedItemsGroupByEnum.SPLIT]: false
} as Record<GroupedItemsGroupByEnum, boolean>;

export const noToggleSameTime = [
  GroupedItemsGroupByEnum.ITEM,
  GroupedItemsGroupByEnum.ITEM_TAGS
  // GroupedItemsGroupBy.ITEM_TAG
];

export const bindingStatusI18nTexts = {
  [GroupedItemBindingStatuses.BINDED]: undefined,
  [GroupedItemBindingStatuses.UNBINDED]: itemsKeys.bindingStatuses.postponed,
  [GroupedItemBindingStatuses.MIXED]: itemsKeys.bindingStatuses.mixed
};

export const bindingStatusIcons = {
  [GroupedItemBindingStatuses.BINDED]: undefined,
  [GroupedItemBindingStatuses.UNBINDED]: IconsEnum.CIRCLE_SOLID,
  [GroupedItemBindingStatuses.MIXED]: IconsEnum.CIRCLE_OUTLINE
};

export const enum GroupedItemsPermissions {
  READ_GROUPED_ITEMS_TABLE_DRAG_ITEMS = 'read_grouped_items_table_drag_items',
  READ_GROUPED_ITEMS_TABLE_DRAG_GROUPED_ITEMS = 'read_grouped_items_table_drag_grouped_items',
  READ_GROUPED_ITEMS_INDEX_MONGO_QUERY = 'read_grouped_items_index_mongo_query',
  READ_CACHE_PROFORMA_GROUPED_ITEMS_QUERY = 'read_cache_proforma_grouped_items_query',
  READ_CACHE_INVOICE_GROUPED_ITEMS_QUERY = 'read_cache_invoice_grouped_items_query',
  SYNC_CACHE_INVOICE_GROUPED_ITEMS = 'sync_cache_invoice_grouped_items'
}

export const GROUPED_ITEM_DND_NODE = 'NODE';

export const groupedItemsTableRowDraggingStyle = {
  opacity: 0.75,
  outline: 'rgb(59, 130, 246) dashed 1px',
  outlineOffset: '-1px'
};
